import { Component, OnInit } from '@angular/core';
import { BeforeSave, RTEAlertService } from 'rte-library';
import { QueryService } from 'src/app/reports/services/query.service';
import { Provider } from '../provider.model';
import { ProviderService } from '../provider.service';
import { getValidation } from '../provider.validation';
import { SchemaColumn, SchemaForm } from '../../../shared/rte-form/schema/schema.model';
import { Schema } from '../../../shared/rte-form/schema/schema.model';
import { PropertyType } from '../../../shared/rte-form/schema/property-type.enum';
import { BaseToolBarCRUDComponent } from 'src/app/reports/shared/utils/base-toolbar-crud.component';
import { assingSchema } from 'src/app/reports/shared/rte-form/schema/schema.helper';
import { permissionToolbar } from 'src/app/reports/helpers/permissiontoolbar';

@Component({
  selector: 'app-provider',
  templateUrl: './provider.component.html',
  styleUrls: ['./provider.component.scss']
})
export class ProviderComponent extends BaseToolBarCRUDComponent<Provider> implements OnInit {

  //#region Proprieties

  columns: SchemaColumn[] = [];
  searchForm: SchemaForm;
  inserForm: SchemaForm;

  nameColumn: Schema;
  descriptionColumn: Schema;
  providerTypeColumn: Schema;
  connectionColumn: Schema;

  //#endregion

  constructor(public service: ProviderService,
  private queryService: QueryService,
  public alert: RTEAlertService) {

    super(alert);
  }

  //#region interface Implementation

  ngOnInit() {
    permissionToolbar(this.toolbarObject);
    this.toolbarObject.current = new Provider();
    this.toolbarObject.searchObject = new Provider();

    this.setCommonSchemas();
    this.configureSearchForm();
    this.configureInserForm();
    this.setColumns();
  }
  //#endregion

  //#region Schemas

  setColumns() {
    this.columns = [
      new SchemaColumn('Código', 'Id'),
      this.nameColumn,
      this.descriptionColumn,
      this.providerTypeColumn
    ];
  }

  configureSearchForm() {

    this.searchForm = {
      Rows : [
        {
          Columns: [
            this.nameColumn,
            this.providerTypeColumn,
          ]
        },
        {
          Columns: [
            this.descriptionColumn
          ]
        }
      ]
    };
  }

  configureInserForm() {

    this.inserForm = {
      Rows : [
        {
          Columns: [
            assingSchema({Required: true}, this.nameColumn),
            assingSchema({Required: true}, this.providerTypeColumn)
          ]
        },
        {
          Columns: [
            this.descriptionColumn
          ]
        },
        {
          Columns: [
            assingSchema({Required: true}, this.connectionColumn),
          ]
        }
      ]
    };
  }

  private setCommonSchemas() {
    this.descriptionColumn = new Schema('Descrição', 'Description', PropertyType.Text);
    this.nameColumn = new Schema('Nome', 'Name', PropertyType.Text);
    this.connectionColumn = new Schema('Conexão', 'ConnectionString', PropertyType.Text, [], { cancelUpperCase: true });

    this.providerTypeColumn = new Schema('Tipo de provedor', 'ProviderType', PropertyType.Select);
    this.providerTypeColumn.Values = this.queryService.getProvidersOptions();
  }

  //#endregion

  //#region Implementation Methods of rte-Toolbar interface

  validateBeforeSave(beforeSave: BeforeSave) {

    const validation = getValidation(this.toolbarObject.current);

    if (validation) {
      beforeSave.cancelSave = true;
      this.alert.warning(validation);
    }
  }

  //#endregion
}
